var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMoreVerticalicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow/dots-vertical"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.29007 8.61108C8.62757 8.61108 8.90118 8.33748 8.90118 7.99997C8.90118 7.66247 8.62757 7.38886 8.29007 7.38886C7.95256 7.38886 7.67896 7.66247 7.67896 7.99997C7.67896 8.33748 7.95256 8.61108 8.29007 8.61108Z",
    stroke: "#425976",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29007 4.33331C8.62757 4.33331 8.90118 4.0597 8.90118 3.7222C8.90118 3.38469 8.62757 3.11108 8.29007 3.11108C7.95256 3.11108 7.67896 3.38469 7.67896 3.7222C7.67896 4.0597 7.95256 4.33331 8.29007 4.33331Z",
    stroke: "#425976",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.29007 12.8889C8.62757 12.8889 8.90118 12.6153 8.90118 12.2778C8.90118 11.9402 8.62757 11.6666 8.29007 11.6666C7.95256 11.6666 7.67896 11.9402 7.67896 12.2778C7.67896 12.6153 7.95256 12.8889 8.29007 12.8889Z",
    stroke: "#425976",
    strokeWidth: 1.22222,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoreVerticalicon);
export default __webpack_public_path__ + "static/media/more-vertical.icon.768e532d43d751dd662cdb48ff3f96d7.svg";
export { ForwardRef as ReactComponent };